export const testimonials = [
  {
    name: '沈一鸣',
    role: '通勤读者',
    text: '地铁上刷十分钟就能把今天的热点理清楚，不用在几个平台之间来回跳。热榜那块我基本每天都看。',
  },
  {
    name: '柳青禾',
    role: '内容运营',
    text: '喜欢它的分寸感。同样一件事，它会标清楚哪些是确认过的，哪些还只是传闻，很少看到标题党。',
  },
  {
    name: '周叙白',
    role: '自由撰稿人',
    text: '素人投稿栏目是我留在这里的原因。真实的故事比热搜更有意思，写的人很会抓细节。',
  },
  {
    name: '何嘉树',
    role: '大学生',
    text: '分类做得很清楚，我想看网红那类的就直接点进去，不用被一堆无关内容淹没。',
  },
  {
    name: '孟舒然',
    role: '产品经理',
    text: '页面干净，加载快，广告感不强。对每天只想快速了解发生了什么的人来说，这很难得。',
  },
  {
    name: '苏怀瑾',
    role: '退休教师',
    text: '我年纪大了，字够大、排版清楚，看久了眼睛也不累。就是希望多讲事实，少点猜测。',
  },
];